module.exports = __webpack_public_path__ + "assets/img/11_660.e49966eb.jpg";